import React, {Component} from "react";
import {Row, Col, Card, CardBody} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

import {connect} from "react-redux";
import ClinicList from "../Clinics/List/ClinicList";
import {
  approveProfessional, editProfessional,
  getProfessionals,
  removeProfessional,
  resetProfessionalQuery
} from "../../store/professionals/actions";
import {userRols} from "../../helpers/userRols";
import Paging from "../../components/Pagination/Pagination";
import LoadingCard from "../../components/LoadingCard/LoadingCard";
import ListSearch from "components/ListSearch/ListSearch";

class Clinics extends Component {
  constructor(props) {
    super(props);
      this.state = {
        selectedLanguage: 'bg' // Default language
      };

    this.onNewClinicModal = this.onNewClinicModal.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.onEdit = this.onEdit.bind(this);
  }

  componentDidMount() {
    this.props.getProfessionals({
      type: userRols.clinic,
      language: this.state.selectedLanguage
    });
  }

  setPage = (currentPage) => {
    this.props.getProfessionals({
      type: userRols.clinic,
      language: this.state.selectedLanguage,
      page: currentPage
    });
  }

  setPageSize = (pageSize) => {
    this.props.getProfessionals({
      type: userRols.clinic,
      language: this.state.selectedLanguage,
      pageSize,
      page: 1
    });
  }

  refreshPage = () => {
    this.props.resetProfessionalQuery();
    this.props.getProfessionals({
      type: userRols.clinic,
      language: this.state.selectedLanguage
    });
  }

  onNewClinicModal() {
    this.props.showAddClinicModal(!this.props.isAddNewClinicOpen);
  }

  onRemove(clinic) {
    this.props.removeProfessional(clinic, userRols.clinic);
  }

  onEdit(clinic) {
    this.props.editProfessional(clinic);
  }

  handleLanguageChange = (language) => {
    this.setState({ selectedLanguage: language }, () => {
      // Reload professionals with selected language
      this.props.getProfessionals({
        type: userRols.clinic,
        language: this.state.selectedLanguage,
        page: 1
      });
    });
  }

  handleSearch = (q) => {
    this.props.getProfessionals({
      type: userRols.clinic,
      language: this.state.selectedLanguage,
      q,
      page: 1
    });
  }

  render() {
    const {professionalList, approveProfessional, history, loadingProfessionals, query} = this.props;
    const {selectedLanguage} = this.state;
    const { page: currentPage, pageSize, q } = query;
    
    // Extract data from the paginated response
    const clinics = professionalList?.users || [];
    const total = professionalList?.total || 0;
    const pages = professionalList?.pages || 1;
    
    return (
      <React.Fragment>
        <div className="page-content">
          <div className="container-fluid">
            <Breadcrumbs title="Клиники" breadcrumbItem="Клиники"/>
            
            <Row>
              <Col>
                {!loadingProfessionals ? (
                  <Card>
                    <CardBody>
                      {/* Header with pagination, search and language selector */}
                      <div className="list-toolbar mb-3">
                        <Paging
                          setPage={this.setPage}
                          setPageSize={this.setPageSize}
                          pageSize={pageSize}
                          currentPage={currentPage}
                          pages={pages}
                        />

                        <ListSearch
                          value={q || ""}
                          onSearch={this.handleSearch}
                          placeholder="Търсене по име, имейл или телефон"
                        />

                        {/* Language Selector */}
                        <div className="language-selector">
                          <button
                            className={`btn btn-sm mx-1 ${selectedLanguage === 'bg' ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => this.handleLanguageChange('bg')}
                          >
                            BG
                          </button>
                          <button
                            className={`btn btn-sm mx-1 ${selectedLanguage === 'en' ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => this.handleLanguageChange('en')}
                          >
                            EN
                          </button>
                        </div>
                      </div>

                      <div className="mb-2 text-muted">
                        Общо: {total} клиники
                      </div>

                      <ClinicList
                        list={{users: clinics}}
                        onRemoveItem={this.onRemove}
                        onEditItem={this.onEdit}
                        onApproveItem={approveProfessional}
                        history={history}
                        language={selectedLanguage}
                      />
                    </CardBody>
                    <Paging 
                      setPage={this.setPage} 
                      setPageSize={this.setPageSize} 
                      pageSize={pageSize} 
                      currentPage={currentPage}
                      pages={pages}
                    />
                  </Card>
                ) : (
                  <LoadingCard />
                )}
              </Col>
            </Row>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const {Professional} = state;
  const query = Professional.query || { page: 1, pageSize: 20, type: '' };
  return {...Professional, query};
};

export default connect(mapStatetoProps, {
  getProfessionals,
  approveProfessional,
  removeProfessional,
  editProfessional,
  resetProfessionalQuery
})(Clinics);
